import { render, staticRenderFns } from "./SertifikatBadgeIcon.vue?vue&type=template&id=322ffe71"
import script from "./SertifikatBadgeIcon.vue?vue&type=script&lang=js"
export * from "./SertifikatBadgeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports